import * as styles from './ListAttachedTags.module.css'

function ListAttachedTags({
  Tag,
  className = styles.ListAttachedTags,
  items,
  tagProps,
}) {
  return (
    <div className={className}>
      {items.map((item, index) => (
        <Tag {...tagProps} item={item} key={item?.id || index} />
      ))}
    </div>
  )
}

export default ListAttachedTags
